import { ReactElement } from 'react';

interface Props {
  children: JSX.Element;
  // eslint-disable-next-line react/require-default-props
  window?: () => Window;
}

export default function BlankLayout({ children }: Props): ReactElement {
  return (
    <>
      {children}
    </>
  );
}
